import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MenuBar from "./screens/MenuBar";
import Home from "./screens/Home";
import LoginCard from "./screens/LoginCard";
import "./App.css";
import { use, useEffect } from "react";

function App() {
  useEffect(() => {
    document.title = "SDM DRS Videos Admin";
  }, []);
  return (
    <Router>
      <MenuBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginCard />} />
      </Routes>
    </Router>
  );
}

export default App;
